<template lang='pug'>
  bf-flex.rsv-stamp.component.centered
    label {{ text }}
</template>

<script>
  export default {
    name: 'rsv-stamp.component',

    props: ['text']
  }
</script>

<style scoped lang='stylus'>
  .rsv-stamp
    color red
    font-size 2.1em
    position absolute
    height 100%
    width 100%
    background rgba( 255 255 255 .5 )
    label
      display block
      transform rotate(-36deg)
      font-family 'Special Elite'
      letter-spacing 2px
</style>
